import { useEffect, useState } from 'react';
import { EVENTS } from '../../../services/constants';
import { eventEmitter } from '../../../services/event-emitter-service';

/**
 * Bumps when LOCATIONS is populated/refreshed so location-derived memos can invalidate.
 * LOCATIONS is a module-level mutable array; this revision is the React dependency.
 */
export const useLocationsRevision = () => {
  const [locationsRevision, setLocationsRevision] = useState(0);

  useEffect(() => {
    const handleLocationsFetched = () => {
      setLocationsRevision((revision) => revision + 1);
    };

    eventEmitter.on(EVENTS.LOCATIONS_FETCHED, handleLocationsFetched);
    return () => {
      eventEmitter.off(EVENTS.LOCATIONS_FETCHED, handleLocationsFetched);
    };
  }, []);

  return locationsRevision;
};
